<template>
  <!-- ROTATING MESSAGES -->
  <div class="info" ref="info">Are you doing your BEST?</div>
</template>

<script>
export default {
  name: "DashboardQuestions",
  data() {
    return {
      words: [
        "Are you doing your BEST?",
        "Are you giving your ALL?",
        "Can you do EVEN more?",
        "Be better, faster?",
        "More CONSCIOUS?",
        "INTENTIONAL? DELIBERATE? DISCIPLINED?",
        "more CREATIVE? DECISIVE? STRATEGIC?",
        "CLEAR? CONCISE? SHARP?",
        "Can you be more?",
        "Can you rest more deeply?",
        "Can you recover faster and more fully?",
        "Learn faster?",
        "Put even more attention to details?",
        "Will you challenge yourself harder?",
        "Push yourself further?",
        "Cross perceived limitations?",
        "Will you do what it takes?",
        "To be really great?",
        "Will you take the pain?",
        "Make the sacrifices?",
        "Take the HEAT?",
        "Find EVEN better ways?",
        "Fly even higher?",
        "RAISE THE BAR?",
        "UP YOUR GAME?",
        "RAISE THE STANDARDS?",
        "EACH. AND. EVERY. DAY?",
        "... And then still ask...",
        "IS THIS THE *BEST* (you can do)?",
        "OR IS THIS ALL YOU GOT?",
        "OR DO YOU HAVE MORE IN YOU?",
        "What is the best version of you?",
        "What does that version of you do?",
        "CAN... YOU... DO",
        "... EVEN BETTER?",
      ],
      currentStep: 0,
      oldWord: "",
    };
  },
  mounted() {
    setTimeout(this.changeWord, 600);
  },
  methods: {
    changeWord() {
      this.oldWord = this.$refs.info.innerHTML;

      // check if there is a word atm or not
      if (this.oldWord.length < 1) {
        if (this.currentStep !== this.words.length - 1) {
          this.currentStep++;
        } else {
          this.currentStep = 0;
        }
        this.addNextWord();
      } else {
        setTimeout(this.deleteWord, 600);
      }
    },

    deleteWord() {
      this.$refs.info.innerHTML = "";
      //   //   let WordLength = this.oldWord.length;
      let currentWord = this.$refs.info.innerHTML;
      let currentLength = currentWord.length;

      //   // The word is deleted so, start adding in the new one
      if (currentLength < 1) {
        this.changeWord();
        return;
      }

      //   // Remove a charachter
      //   this.$refs.info.innerHTML = currentWord.substring(0, currentLength - 1);

      //   this.deleteWord();
    },

    addNextWord() {
      let currentWord = this.$refs.info.innerHTML;
      let currentLength = currentWord.length;
      let nextWord = this.words[this.currentStep];
      let nextWordLength = nextWord.length;

      if (currentLength === nextWordLength) {
        this.changeWord();
        return;
      }

      // add a charachter
      this.$refs.info.innerHTML = nextWord.substring(0, currentLength + 1);

      setTimeout(this.addNextWord, 100);
    },
  },
};
</script>

<style scoped>
.info {
  font-size: 50px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: black;
  color: white;
}
</style>